import React from 'react';
import { BookOpenIcon, BusIcon, CalendarDaysIcon, CreditCardIcon, HomeIcon, LifeBuoyIcon, UserIcon, UtensilsIcon, BellIcon, ChevronRightIcon, LayoutGridIcon } from 'lucide-react';
import { campusNews, quickActions, todaySchedule, VINUNI_LOGO_HORIZONTAL } from '../data/homeScreen';
const icons = {
  calendar: CalendarDaysIcon,
  book: BookOpenIcon,
  card: CreditCardIcon,
  bus: BusIcon,
  utensils: UtensilsIcon,
  help: LifeBuoyIcon
};
export function MyVinUniHome() {
  return <div className="lexce-scroll h-full overflow-y-auto bg-vin-mist pb-28" data-id="element-180" data-mp="ufgs32xf5z7s">
      <header className="bg-vin-primary px-5 pb-8 pt-3 text-white" data-id="element-181" data-mp="pgdn1ihfvszt">
        <div className="flex items-center justify-between text-[11px] font-semibold text-white/80" data-id="element-182" data-mp="piq4lujac1cc">
          <span data-id="element-183" data-mp="lh4xyqxcgjal">10:34</span>
          <span data-id="element-184" data-mp="2juel41560byu">4G</span>
        </div>
        <div className="mt-4 flex items-center justify-between" data-id="element-185" data-mp="2jtdc027plzjr">
          <img src={VINUNI_LOGO_HORIZONTAL} alt="VinUniversity" className="h-6 w-auto brightness-0 invert" data-id="element-186" data-mp="2fsjmx5ij6epa" />
          <button type="button" aria-label="Notifications" className="relative rounded-full bg-white/10 p-2 transition-colors duration-150 ease-out hover:bg-white/20" data-id="element-187" data-mp="yer7fh5s5kkh">
            <BellIcon className="h-4 w-4" aria-hidden="true" data-id="element-188" data-mp="phqlria3i0kq" />
            <span className="absolute right-1.5 top-1.5 h-1.5 w-1.5 rounded-full bg-vin-secondary" data-id="element-189" data-mp="thr1d68xkhtd" />
          </button>
        </div>
        <p className="mt-6 text-[13px] text-white/70" data-id="element-190" data-mp="1h8wdpbfnwryx">Good morning,</p>
        <h1 className="text-[26px] font-bold leading-8" data-id="element-191" data-mp="1m550nb03ppgn">Minh Anh Trần</h1>
        <p className="mt-1 text-[12px] text-white/70" data-id="element-192" data-mp="18f1fkncyk1ss">BBA, Year 1 · College of Business & Management</p>
      </header>

      <main className="-mt-4 space-y-5 px-4" data-id="element-193" data-mp="1ceimzmby390l">
        <section className="rounded-2xl bg-white p-4 shadow-card" data-id="element-194" data-mp="205fsag98j82v">
          <div className="grid grid-cols-3 gap-y-4" data-id="element-195" data-mp="2044oigfsi0br">
            {quickActions.map(action => {
            const Icon = icons[action.icon];
            return <button key={action.label} type="button" className="flex flex-col items-center gap-2 rounded-xl py-1 transition-colors duration-150 ease-out hover:bg-vin-mist focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-vin-tertiary" data-id="element-196" data-mp="2er39pto1zyi1">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-vin-mist text-vin-primary" data-id="element-197" data-mp="1vt0hl607llg0">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-198" data-mp="1r2abfqjylek9" />
                  </span>
                  <span className="text-[11px] font-medium text-vin-ink" data-id="element-199" data-mp="1n0fe0x55flbr">{action.label}</span>
                </button>;
          })}
          </div>
        </section>

        <section data-id="element-200" data-mp="1d2rfdw4f9tob">
          <div className="flex items-baseline justify-between" data-id="element-201" data-mp="1d3ankl49t3p5">
            <h2 className="text-[15px] font-bold text-vin-ink" data-id="element-202" data-mp="1d4lsio9gchhu">Today</h2>
            <button type="button" className="flex items-center text-[12px] font-semibold text-vin-tertiary" data-id="element-203" data-mp="1847tfvptwhvy">
              Full timetable
              <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-204" data-mp="12yu8vv2j1smx" />
            </button>
          </div>
          <ul className="mt-2 space-y-2" data-id="element-205" data-mp="17y6y2mgvfbso">
            {todaySchedule.map(item => <li key={item.code} className={`flex items-center gap-3 rounded-2xl bg-white px-3.5 py-3 shadow-card ${item.state === 'now' ? 'ring-1 ring-vin-secondary/40' : ''}`} data-id="element-206" data-mp="1cx0dikfpxcvh">
                <span className="w-11 text-[13px] font-bold text-vin-primary" data-id="element-207" data-mp="k8mcdvtc20fp">{item.time}</span>
                <span className="h-9 w-px bg-vin-line" data-id="element-208" data-mp="p64mvqn00npt" />
                <span className="min-w-0 flex-1" data-id="element-209" data-mp="tynwydmh90pv">
                  <span className="block truncate text-[13px] font-semibold text-vin-ink" data-id="element-210" data-mp="u08v0d8031sh">{item.name}</span>
                  <span className="block text-[11px] text-vin-muted" data-id="element-211" data-mp="3sm1w9xdc5rn3">
                    {item.code} · {item.room}
                  </span>
                </span>
                {item.state === 'now' && <span className="rounded-full bg-vin-secondary px-2 py-0.5 text-[10px] font-bold uppercase text-white" data-id="element-212" data-mp="234od4yqpwlka">
                    Now
                  </span>}
              </li>)}
          </ul>
        </section>

        <section data-id="element-213" data-mp="285byp4w6ga74">
          <h2 className="text-[15px] font-bold text-vin-ink" data-id="element-214" data-mp="284ss2kbz988e">Campus news</h2>
          <div className="lexce-scroll mt-2 flex gap-3 overflow-x-auto pb-1" data-id="element-215" data-mp="2lwgzwbf71ajk">
            {campusNews.map(item => <article key={item.title} className="w-52 shrink-0 overflow-hidden rounded-2xl bg-white shadow-card" data-id="element-216" data-mp="2hvnf3qx1sbuw">
                <img src={item.image} alt="" className="h-24 w-full object-cover" data-id="element-217" data-mp="2qwbv2r604maf" />
                <div className="p-3" data-id="element-218" data-mp="11h5cp1ky5bra">
                  <p className="text-[10px] font-semibold uppercase tracking-wide text-vin-tertiary" data-id="element-219" data-mp="11i7107qz3uqy">{item.tag}</p>
                  <h3 className="mt-1 text-[13px] font-semibold leading-4 text-vin-ink" data-id="element-220" data-mp="wkex0fd20i6e">{item.title}</h3>
                </div>
              </article>)}
          </div>
        </section>
      </main>

      <nav className="absolute bottom-0 left-0 right-0 flex items-center justify-around border-t border-vin-line bg-white/95 px-2 pb-5 pt-2 backdrop-blur" data-id="element-221" data-mp="3d73dtzcv3h9v">
        {[{
        label: 'Home',
        Icon: HomeIcon,
        active: true
      }, {
        label: 'Timetable',
        Icon: CalendarDaysIcon,
        active: false
      }, {
        label: 'Services',
        Icon: LayoutGridIcon,
        active: false
      }, {
        label: 'Me',
        Icon: UserIcon,
        active: false
      }].map(({
        label,
        Icon,
        active
      }) => <button key={label} type="button" className={`flex w-16 flex-col items-center gap-1 text-[10px] font-medium ${active ? 'text-vin-primary' : 'text-vin-muted'}`} data-id="element-222" data-mp="2fitbfj95yri8">
            <Icon className="h-5 w-5" aria-hidden="true" data-id="element-223" data-mp="ioq6v4w4ifos" />
            {label}
          </button>)}
      </nav>
    </div>;
}